import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { OrderDetailsContext } from '../../../context/OrderDetailsContext';

const OrderStatusContainer = ({
  order,
  orderCompleted,
  orderDispatched,
  minsBeforeCheck,
  orderIsCancelled,
  deliveryBeforeSlottedTime,
}) => {
  const [statusTimeStamp, setStatusTimeStamp] = useState();
  const { orderDetail, orderType } = useContext(OrderDetailsContext);
  const [orderStatusHistories, setOrderStatusHistories] = useState([]);

  // if any error in delivery get status
  const [attemptedDelivery, setattemptedDelivery] = useState('false');

  // get all the available order status histories
  useEffect(() => {
    setOrderStatusHistories(orderDetail?.response?.orderStatusHistories);
  }, [orderDetail]);

  // sort the order histories with timestamp
  const sortedOrderStatusHistories = orderStatusHistories?.sort(function (
    a,
    b
  ) {
    var c = a.syncedOn;
    var d = b.syncedOn;
    return c - d;
  });

  // Filter required status for tracker from sorted histories
  useEffect(() => {
    // get the timestamp of current order
    if (orderDetail?.response?.orderState === 'Completed') {
      setStatusTimeStamp(
        moment(orderDetail?.response?.lastUpdatedStatusOn).format()
      );
    } else {
      sortedOrderStatusHistories
        ?.filter((orderStatuses) => orderStatuses.status === order.status)
        // eslint-disable-next-line
        ?.map((order) => {
          setStatusTimeStamp(moment(order?.syncedOn).format());
        });
    }

    // check if attempted deliver issue present
    sortedOrderStatusHistories
      ?.filter((orderStatuses) => orderStatuses.status === 'Hold')
      // eslint-disable-next-line
      ?.map((order) => {
        setattemptedDelivery('true');
      });
  }, [order, orderDetail, sortedOrderStatusHistories]);

  let currentTime = new Date().getTime();
  let minBeforeEnd = new Date(minsBeforeCheck).getTime();

  return (
    <>
      {attemptedDelivery === 'true' &&
        order.status === 'Hold' &&
        order.statusEnabled && (
          <li
            className={
              orderIsCancelled === 'true'
                ? 'orderStatusContainerGrey'
                : `${
                    order.statusType === 'alert'
                      ? 'orderStatusContainerRed'
                      : `${
                          statusTimeStamp
                            ? 'orderStatusContainer'
                            : 'orderStatusContainerGrey'
                        }`
                  }`
            }
          >
            <div
              className={`statusHeading ${
                orderIsCancelled === 'true'
                  ? ''
                  : `${statusTimeStamp && 'bold'}`
              }`}
            >
              {order.orderName}
            </div>
            {statusTimeStamp && (
              <div className="timeCont">
                <p className="time">{moment(statusTimeStamp).format('LT')}</p>
              </div>
            )}
            <p
              className={`${
                orderIsCancelled === 'true'
                  ? 'orderDesc'
                  : `${statusTimeStamp ? 'boldDesc' : 'orderDesc'}`
              }`}
            >
              {order.desc}
            </p>
            {order.desc2 && (
              <p
                c
                className={`${
                  orderIsCancelled === 'true'
                    ? 'orderDesc'
                    : `${statusTimeStamp ? 'boldDesc' : 'orderDesc'}`
                }`}
              >
                {order.desc2}
              </p>
            )}
          </li>
        )}

      {attemptedDelivery === 'false' &&
        order.status === 'Placed' &&
        order.statusEnabled === 'enabled' && (
          <li
            className={
              orderIsCancelled === 'true'
                ? 'orderStatusContainerGrey'
                : 'orderStatusContainer'
            }
          >
            {orderType === 'slotted' ? (
              <div
                className={`statusHeading ${
                  orderIsCancelled === 'true' ? '' : 'bold'
                }`}
              >
                Order Acknowledged
              </div>
            ) : (
              <div
                className={`statusHeading ${
                  orderIsCancelled === 'true' ? '' : 'bold'
                }`}
              >
                {order.orderName}
              </div>
            )}

            {orderIsCancelled === 'true' ? (
              ''
            ) : (
              <div className="timeCont">
                <p className="time">
                  {orderType === 'slotted' ? (
                    <>
                      {deliveryBeforeSlottedTime === 'true' ? (
                        ''
                      ) : (
                        <>
                          {moment(orderDetail?.response?.timeSlotStart).format(
                            'LT'
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {moment(orderDetail?.response?.sourceCreatedOn).format(
                        'LT'
                      )}
                    </>
                  )}
                </p>
              </div>
            )}
            {orderType === 'slotted' ? (
              <p
                className={`${
                  orderIsCancelled === 'true' ? 'orderDesc' : 'boldDesc'
                }`}
              >
                Sit back and relax while we deliver your freshly cut order to
                your home!
              </p>
            ) : (
              <p
                className={`${
                  orderIsCancelled === 'true' ? 'orderDesc' : 'boldDesc'
                }`}
              >
                {order.desc}
              </p>
            )}
            {order.desc2 && (
              <p
                className={`${
                  orderIsCancelled === 'true' ? 'orderDesc' : 'boldDesc'
                }`}
              >
                {order.desc2}
              </p>
            )}
          </li>
        )}

      {attemptedDelivery === 'false' &&
        order.status === 'Acknowledged' &&
        order.statusEnabled === 'enabled' && (
          <li
            className={
              orderIsCancelled === 'true'
                ? 'orderStatusContainerGrey'
                : `${
                    order.statusType === 'alert'
                      ? 'orderStatusContainerRed'
                      : `${
                          statusTimeStamp
                            ? 'orderStatusContainer'
                            : 'orderStatusContainerGrey'
                        }`
                  }`
            }
          >
            <div
              className={`statusHeading ${
                orderIsCancelled === 'true'
                  ? ''
                  : `${statusTimeStamp && 'bold'}`
              }`}
            >
              {order.orderName}
            </div>
            {orderType === 'slotted' ? (
              <p
                className={`${
                  orderIsCancelled === 'true'
                    ? 'orderDesc'
                    : `${statusTimeStamp ? 'boldDesc' : 'orderDesc'}`
                }`}
              >
                Your order is being freshly cut right now.
              </p>
            ) : (
              <p
                className={`${
                  orderIsCancelled === 'true'
                    ? 'orderDesc'
                    : `${statusTimeStamp ? 'boldDesc' : 'orderDesc'}`
                }`}
              >
                {order.desc}
              </p>
            )}
          </li>
        )}

      {attemptedDelivery === 'false' &&
      (order.status === 'Hold' ||
        order.status === 'Placed' ||
        order.status === 'Acknowledged') ? (
        ''
      ) : (
        <>
          {order.statusEnabled === 'enabled' && (
            <li
              className={
                orderIsCancelled === 'true'
                  ? 'orderStatusContainerGrey'
                  : `${
                      order.statusType === 'alert'
                        ? 'orderStatusContainerRed'
                        : `${
                            statusTimeStamp
                              ? `${
                                  orderDispatched &&
                                  currentTime >= minBeforeEnd &&
                                  !orderCompleted
                                    ? 'orderStatusContainer2'
                                    : 'orderStatusContainer'
                                }`
                              : 'orderStatusContainerGrey'
                          }`
                    }`
              }
            >
              <div
                className={`statusHeading ${
                  orderIsCancelled === 'true'
                    ? ''
                    : `${statusTimeStamp && 'bold'}`
                }`}
              >
                {order.orderName}
              </div>
              <p
                className={`${
                  orderIsCancelled === 'true'
                    ? 'orderDesc'
                    : `${statusTimeStamp ? 'boldDesc' : 'orderDesc'}`
                }`}
              >
                {order.desc}
              </p>
              {order.desc2 && (
                <p
                  className={`${
                    orderIsCancelled === 'true'
                      ? 'orderDesc'
                      : `${statusTimeStamp ? 'boldDesc' : 'orderDesc'}`
                  }`}
                >
                  {order.desc2}
                </p>
              )}
              {order?.status === 'TRIP START' && (
                <>
                  {orderDispatched && (
                    <>
                      {currentTime >= minBeforeEnd && (
                        <>
                          {!orderCompleted && (
                            <>
                              {orderIsCancelled === 'true' ? (
                                ''
                              ) : (
                                <>
                                  {orderDetail?.response?.deliveryuserMobile &&
                                    orderDetail?.response?.deliveryUserName && (
                                      <div className="alertContainer">
                                        <p className="alertDesc">
                                          Delivery Executive :{' '}
                                          {orderDetail?.response?.deliveryUserName?.substring(
                                            0,
                                            15
                                          )}{' '}
                                          <a
                                            href={`tel:+91${orderDetail?.response?.deliveryuserMobile}`}
                                            className="mobileLink"
                                          >
                                            <span className="callIconSm">
                                              <i className="fa fa-phone-alt"></i>
                                            </span>
                                          </a>
                                        </p>
                                      </div>
                                    )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </li>
          )}
        </>
      )}
    </>
  );
};

export default OrderStatusContainer;
